import { useEffect, useState } from 'react';
import styles from "./BackToTopButton.module.scss"; 
import { getCurrentPageTypeCookie } from '@/helpers/generalHelper';
import { useRouter } from 'next/compat/router';
 
const BackToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [pageType, setPageType] = useState("");
    const router= useRouter();
 
    const handleScroll = () => {
        if (window.scrollY > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };
 
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };
 
    useEffect(() => {
        let pageName = getCurrentPageTypeCookie();
        let pageMapping = pageName?.type=="collection"?"PLP":
                          pageName?.type=="product"?"PDP":
                          router.asPath==("/")?"Homepage":
                          router.asPath.includes("/impact")||router.asPath.includes("/charity")?"Impact":
                          router.asPath.includes("/editorial")?"Editorial":
                          router.asPath.includes("/rewards")?"Rewards":
                          "Content";
                          
        setPageType(pageMapping);
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
 
    return (
    <button
        onClick={scrollToTop}
        className={`${styles.BackToTopButton} ${isVisible?"":"d-none"} ga-back-to-top`}        
        dataPageType={pageType}
    ></button>
    );
};
 
export default BackToTopButton;